import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import FbSalesReport from './FbSalesReport'

const FbSalesSummary = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="F&B Sales Summary" mainTitle="F&B Sales Summary" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <FbSalesReport />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default FbSalesSummary